export type PushPlatform = "ios" | "android";

export interface PushPermissionState {
  pushPermissionAsked: boolean | null;
  deviceToken: string | null;
}

export const getPushPermission = async (
  accessAuthToken: string,
  platform: PushPlatform
): Promise<PushPermissionState> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/users/push-permission?platform=${platform}`;
  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${accessAuthToken}` },
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to get push permission status");
  return response.json();
};

export const markPushPermissionAsked = async (
  accessAuthToken: string,
  platform: PushPlatform
): Promise<{ pushPermissionAsked: boolean }> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/users/push-permission`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ platform }),
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to mark push permission as asked");
  return response.json();
};

export const savePushDeviceToken = async (
  accessAuthToken: string,
  deviceToken: string,
  platform: PushPlatform
): Promise<{ pushPermissionAsked: boolean; deviceToken: string }> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/users/push-permission/device-token`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ deviceToken, platform }),
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to save push device token");
  return response.json();
};
